import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject  } from 'rxjs';

@Injectable()
export class DatepickerService {
  private datepickerToken;
  protected settings: any = new Array();
  private uniqueKey: number;
  private modelUpdate = new Subject();
  public modelUpdateObservable = this.modelUpdate.asObservable();
  public  inputElement = new BehaviorSubject('');
  currentDateInput = this.inputElement.asObservable();
  public useLocale: string;
  generateKey(): number {
    const randomKey = new Date().valueOf() + Math.random() * 1000;
    if (this.getDatepickerInstance() === randomKey) {
      this.generateKey();
    } else {
      return randomKey;
    }
  }
  setDatepickerInstance(instance) {
    this.uniqueKey = this.generateKey();
    this.settings[this.uniqueKey] = instance;
  }
  getDatepickerInstance() {
    return this.settings[this.uniqueKey];
  }

  anounceModelUpdate(modelValue) {
    this.modelUpdate.next(modelValue);
  }
  destroyData() {
    delete this.settings[this.uniqueKey];
  }
  inputDateElement(element) {
    this.inputElement.next(element);
  }
  isDisabledDay(disableDays: number[], date) {
    let isDisabled = false;
    if (disableDays && disableDays.length > 0 && date) {
      if (disableDays.indexOf(date.getDay()) > -1) {
        isDisabled = true;
      }
    }
    return isDisabled;
  }
  isDisabledDate(disableDates, selectedDate) {
    let isDisabled = false;
    disableDates.forEach(date => {
      if (date.d === selectedDate.getDate()) {
        if (date.m - 1 === selectedDate.getMonth()) {
          if ('y' in date) {
            if (date.y === selectedDate.getFullYear()) {
              isDisabled = true;
            }
          } else {
            isDisabled = true;
          }
        }
      }
    });
    return isDisabled;
  }
}
